export const CDP_SETTINGS_SETUP_STEP_ID = 'cdp-settings-setup';
export const MYAUTOIQ_SETTINGS_SETUP_STEP_ID = 'myautoiq-settings-setup';
export const SANDBOX_READINESS_SETUP_STEP_ID = 'sandbox-readiness-setup';
export const CRM_SUPPORTS_EMAIL_REPORTS_KEY = 'crm_supports_email_reports';
export const SANDBOX_READINESS_REQUIRED_KEY = 'sandbox_readiness_required';
export const CRM_MAILGUN_ROUTES_CHECKLIST_ID = 'crm-mailgun-routes-configured';
export const UNSOLD_TEST_LEAD_CHECKLIST_ID = 'unsold-test-lead-available';

export type OnboardingStepContextMap = Record<string, Record<string, unknown>>;

export function getCrmSupportsEmailReportsSelection(
  stepContext?: OnboardingStepContextMap | null,
): boolean | null {
  const value =
    stepContext?.[CDP_SETTINGS_SETUP_STEP_ID]?.[CRM_SUPPORTS_EMAIL_REPORTS_KEY];
  if (typeof value !== 'boolean') {
    return null;
  }
  return value;
}

export function hasCrmSupportsEmailReportsSelection(
  stepContext?: OnboardingStepContextMap | null,
): boolean {
  return getCrmSupportsEmailReportsSelection(stepContext) !== null;
}

export function getCrmSupportsEmailReports(
  stepContext?: OnboardingStepContextMap | null,
): boolean {
  return getCrmSupportsEmailReportsSelection(stepContext) === true;
}

export function buildCrmSupportsEmailReportsStepContext(
  enabled: boolean,
): OnboardingStepContextMap {
  return {
    [CDP_SETTINGS_SETUP_STEP_ID]: {
      [CRM_SUPPORTS_EMAIL_REPORTS_KEY]: enabled,
    },
  };
}

export function getSandboxReadinessRequiredSelection(
  stepContext?: OnboardingStepContextMap | null,
): boolean | null {
  const value =
    stepContext?.[SANDBOX_READINESS_SETUP_STEP_ID]?.[SANDBOX_READINESS_REQUIRED_KEY];
  if (typeof value !== 'boolean') {
    return null;
  }
  return value;
}

export function hasSandboxReadinessRequiredSelection(
  stepContext?: OnboardingStepContextMap | null,
): boolean {
  return getSandboxReadinessRequiredSelection(stepContext) !== null;
}

export function getSandboxReadinessRequired(
  stepContext?: OnboardingStepContextMap | null,
): boolean {
  return getSandboxReadinessRequiredSelection(stepContext) === true;
}

export function buildSandboxReadinessRequiredStepContext(
  required: boolean,
): OnboardingStepContextMap {
  return {
    [SANDBOX_READINESS_SETUP_STEP_ID]: {
      [SANDBOX_READINESS_REQUIRED_KEY]: required,
    },
  };
}

export function resolveSandboxReadinessCanComplete(
  validation: { checklist: Array<{ id: string; required?: boolean; validated: boolean }> } | null,
  sandboxReadinessRequired: boolean | null,
): boolean {
  if (sandboxReadinessRequired === null) {
    return false;
  }

  if (!validation) {
    return true;
  }

  const requiredItems = validation.checklist.filter(item => {
    if (item.id === UNSOLD_TEST_LEAD_CHECKLIST_ID && !sandboxReadinessRequired) {
      return false;
    }
    return item.required !== false;
  });

  return requiredItems.length === 0 || requiredItems.every(item => item.validated);
}

export function resolveCdpSettingsCanComplete(
  validation: { checklist: Array<{ id: string; required?: boolean; validated: boolean }> } | null,
  crmSupportsEmailReports: boolean | null,
): boolean {
  if (crmSupportsEmailReports === null) {
    return false;
  }

  if (!validation) {
    return true;
  }

  const requiredItems = validation.checklist.filter(item => {
    if (item.id === CRM_MAILGUN_ROUTES_CHECKLIST_ID && !crmSupportsEmailReports) {
      return false;
    }
    return item.required !== false;
  });

  return requiredItems.length === 0 || requiredItems.every(item => item.validated);
}
